// Created on 2023-08-03
// Created by Vitaut Tryputsin
//
// Copyright (c) 2023 OPEN CASCADE SAS
//
// This file is part of commercial software by OPEN CASCADE SAS,
// furnished in accordance with the terms and conditions of the contract
// and with the inclusion of this copyright notice.
// This file or any part thereof may not be provided or otherwise
// made available to any third party.
//
// No ownership title to the software is transferred hereby.
//
// OPEN CASCADE SAS makes no representation or warranties with respect to the
// performance of this software, and specifically disclaims any responsibility
// for any damages, special or consequential, connected with its use.
/**
 * This enumeration defines line types.
 * It reflects values of corresponding C++ `Aspect_TypeOfLine` enumeration defined by OCCT.
 *
 * For using this enum please use its implementation from [[OccViewer.Aspect_TypeOfLine]].
 */
export var Aspect_TypeOfLine;
(function (Aspect_TypeOfLine) {
    /** Hidden, `Aspect_TOL_EMPTY`. */
    Aspect_TypeOfLine[Aspect_TypeOfLine["EMPTY"] = -1] = "EMPTY";
    /** Continuous, `Aspect_TOL_SOLID`. */
    Aspect_TypeOfLine[Aspect_TypeOfLine["SOLID"] = 0] = "SOLID";
    /** Dashed, `Aspect_TOL_DASH`. */
    Aspect_TypeOfLine[Aspect_TypeOfLine["DASH"] = 1] = "DASH";
    /** Dotted, `Aspect_TOL_DOT`. */
    Aspect_TypeOfLine[Aspect_TypeOfLine["DOT"] = 2] = "DOT";
    /** Mixed, `Aspect_TOL_DOTDASH`. */
    Aspect_TypeOfLine[Aspect_TypeOfLine["DOTDASH"] = 3] = "DOTDASH";
})(Aspect_TypeOfLine || (Aspect_TypeOfLine = {}));
